import type { ReactNode } from "react";
import { ActivityIndicator, Image, StyleSheet, View } from "react-native";
import { BackgroundGradient } from "~/components/layout/BackgroundGradient";
import { Subtitle, Title } from "~/components/layout/text";
import { Only } from "~/components/permission/Only";
import { useTheme } from "~/providers/ThemeProvider";

export type LoadingMaskProps = {
    title?: ReactNode;
    subtitle?: ReactNode;
};

export const LoadingMask = ({ title, subtitle }: LoadingMaskProps) => {
    const { colours } = useTheme();

    return (
        <View style={styles.loading}>
            <BackgroundGradient />
            <Image source={require("~/assets/title-logo.png")} style={styles.image} alt="QENDO" />
            <Only when={title}>
                <Title>{title}</Title>
            </Only>
            <Only when={subtitle}>
                <Subtitle>{subtitle}</Subtitle>
            </Only>
            <ActivityIndicator size="large" color={colours.icon.tertiary} />
        </View>
    );
};

const styles = StyleSheet.create({
    image: {
        width: 220,
        height: 182,
    },
    loading: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        gap: 40,
        zIndex: 9000,
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "transparent",
    },
});
